import type {ReactElement} from 'react';
import React from 'react';
import {BaseVolumeOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-volume-option/base-volume-option';
import {useGetKeyFromActiveVideoItem} from '@Hooks/poster-editor/useGetKeyFromActiveVideoItem';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {VideoItem} from '@PosterWhiteboard/items/video-item/video-item.class';
import type {SlideshowItem} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';

export function VideoItemVolumeOption(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? (window.posterEditor?.whiteboard?.getItemForId(activeItemId) as VideoItem | SlideshowItem) : undefined;
  const volume = useGetKeyFromActiveVideoItem('volume');

  if (!activeItem || volume === undefined) {
    return null;
  }

  if (!activeItem.isVideo()) {
    return null;
  }

  if (!activeItem.hasAudio) {
    return null;
  }

  const updateAudioItemVolume = (val: number, undoable: boolean): void => {
    void activeItem.updateFromObject({volume: val}, {undoable});
  };

  const onMuteUnmute = (): void => {
    activeItem.toggleMuteUnmuteState();
  };

  return <BaseVolumeOption onMuteUnmute={onMuteUnmute} volume={volume} onUpdateVolume={updateAudioItemVolume} />;
}
